import { FC, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useGetPartnersQuery } from '@/apiSlices';
import { TPartnerId, useSelectedPartnerId } from '@/redux/partners-slice.ts';
import {
	Chevron,
	Container,
	CurrentSelection,
	Menu,
	MenuItem,
	MenuSeparator,
	PartnerDetails,
	PartnerLabel,
	PartnerLogoAlt,
	PartnerLogoImage
} from './PartnerPicker-styles';
import { useRecentPartners } from './useRecentPartners';

const PartnerLogo: FC<{ url?: string; name?: string }> = ({ url, name = '' }) => {
	return url ? <PartnerLogoImage src={url} alt={name} /> : <PartnerLogoAlt>{name.substring(0, 1)}</PartnerLogoAlt>;
};

export const PartnerPicker: FC = () => {
	const containerElementRef = useRef<HTMLDivElement>(null);
	const { data: partners } = useGetPartnersQuery({});
	const recentPartners = useRecentPartners();
	const navigate = useNavigate();
	const selectedPartnerId = useSelectedPartnerId();

	const selectedPartner = partners?.find(({ id }) => id === selectedPartnerId);

	const pickPartner = (partnerId: TPartnerId) => {
		(containerElementRef.current as HTMLElement).blur();
		navigate(`/?partnerId=${partnerId}`);
	};

	if (!partners?.length) {
		return null;
	}

	return (
		<Container tabIndex={0} ref={containerElementRef}>
			<CurrentSelection>
				<PartnerDetails>
					<PartnerLogo url={selectedPartner?.iconLogoUrl} name={selectedPartner?.name} />
					<PartnerLabel>{selectedPartner?.name}</PartnerLabel>
				</PartnerDetails>
				<Chevron />
			</CurrentSelection>
			<Menu>
				{recentPartners.length && (
					<>
						{recentPartners.map(({ id, partnerKey, name, iconLogoUrl }) => (
							<MenuItem key={partnerKey} onClick={() => pickPartner(id)}>
								<PartnerDetails>
									<PartnerLogo url={iconLogoUrl} name={name} />
									<PartnerLabel>{name}</PartnerLabel>
								</PartnerDetails>
							</MenuItem>
						))}
						<MenuSeparator />
					</>
				)}

				{partners.map(({ id, name, iconLogoUrl }) => (
					<MenuItem key={id} onClick={() => pickPartner(id)}>
						<PartnerDetails>
							<PartnerLogo url={iconLogoUrl} name={name} />
							<PartnerLabel>{name}</PartnerLabel>
						</PartnerDetails>
					</MenuItem>
				))}
			</Menu>
		</Container>
	);
};
